import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_resolveDynamicComponent($options.type), _normalizeProps(_guardReactiveProps($options.linkProps($props.to))), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
      meta: $props.meta
    })]),
    _: 3
  }, 16);
}